import { render, staticRenderFns } from "./users-answers.vue?vue&type=template&id=0e95338e&lang=pug"
import script from "./users-answers.vue?vue&type=script&lang=js"
export * from "./users-answers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports